/* ==========================================================================
   ATOMGYM — 1:1 ARNTREAL INTERACTIVE ENGINE & BULLETPROOF CART ENGINE
   ========================================================================== */

(function () {
  'use strict';

  const LOCAL_CART_KEY = 'atomgym_cart_v1';

  /* ------------------------------------------------------------------------
     1. GUARANTEED IOS SAFARI VIDEO PLAYBACK (HERO + 2ND BACKSTAGE VIDEO)
     ------------------------------------------------------------------------ */
  function initVideos() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const videos = document.querySelectorAll('video[data-video-managed]');

    videos.forEach((video) => {
      const targetSrc = isMobile
        ? video.getAttribute('data-src-mobile')
        : video.getAttribute('data-src-desktop');

      if (targetSrc && video.getAttribute('src') !== targetSrc) {
        video.setAttribute('src', targetSrc);
        video.load();
      }

      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('muted', '');

      const tryPlay = () => {
        if (video.paused) {
          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {});
          }
        }
      };

      video.addEventListener('loadedmetadata', tryPlay);
      video.addEventListener('canplay', tryPlay);
      tryPlay();

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                tryPlay();
              }
            });
          },
          { threshold: 0.05 }
        );
        io.observe(video);
      }
    });

    const unlockAllVideos = () => {
      videos.forEach((v) => {
        v.muted = true;
        if (v.paused) {
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        }
      });
    };

    window.addEventListener('touchstart', unlockAllVideos, { passive: true, once: true });
    window.addEventListener('scroll', unlockAllVideos, { passive: true, once: true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) unlockAllVideos();
    });
  }

  /* ------------------------------------------------------------------------
     2. CART STATE HELPERS & MONEY FORMATTER
     ------------------------------------------------------------------------ */
  function formatMoney(centsOrEuros) {
    if (centsOrEuros === null || centsOrEuros === undefined) return '0,00 €';
    const val = centsOrEuros > 200 ? (centsOrEuros / 100) : centsOrEuros;
    return val.toFixed(2).replace('.', ',') + ' €';
  }

  function getLocalCart() {
    try {
      const raw = localStorage.getItem(LOCAL_CART_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveLocalCart(items) {
    try {
      localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(items));
    } catch (e) {}
    updateCartUI();
  }

  function syncShopifyBackend(variantId, qty) {
    try {
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: parseInt(qty || 1, 10)
        })
      }).catch(() => {});
    } catch (e) {}
  }

  function updateCartUI() {
    const items = getLocalCart();
    const totalCount = items.reduce((sum, item) => sum + (item.qty || 1), 0);
    const totalPrice = items.reduce((sum, item) => sum + ((item.price || 59.99) * (item.qty || 1)), 0);

    // 1. Header Badges
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = totalCount;
    });

    // 2. Cart Drawer Items
    const drawerItems = document.getElementById('cart-drawer-items');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    const progressFill = document.getElementById('cart-progress-fill');
    const progressMsg = document.getElementById('cart-progress-msg');
    const checkoutLink = document.getElementById('cart-drawer-checkout-link');

    if (drawerItems) {
      if (items.length === 0) {
        drawerItems.innerHTML = `
          <div style="padding: 48px 20px; text-align: center; color: #767676;">
            <p style="font-size: 13.5px; font-weight: 700; text-transform: uppercase; margin-bottom: 8px; color: #000;">Votre panier est vide</p>
            <p style="font-size: 12.5px; color: #666; margin-bottom: 20px;">Découvrez nos Ensembles Performance et la Capsule HMI.</p>
            <a href="/#collection" class="button" style="display: inline-block; padding: 12px 24px; font-size: 12px; background: #000; color: #fff; text-decoration: none;">DÉCOUVRIR LA COLLECTION</a>
          </div>
        `;
        if (checkoutLink) {
          checkoutLink.setAttribute('href', '/checkout');
        }
      } else {
        drawerItems.innerHTML = items.map((item) => {
          const lineTotal = (item.price || 59.99) * (item.qty || 1);
          return `
            <div class="line-item" data-vid="${item.variantId}">
              <div class="line-item__media">
                <img src="${item.image || ''}" alt="${item.title}" loading="lazy">
              </div>
              <div class="line-item__info">
                <div class="line-item__title">${item.title}</div>
                <div class="line-item__variant">Taille ${item.size || 'M'}</div>
                <div class="line-item__price">${formatMoney(lineTotal)}</div>
                <div class="line-item__actions">
                  <div class="quantity-selector">
                    <button type="button" class="quantity-selector__button" data-qty-change="-1" data-vid="${item.variantId}" aria-label="Diminuer">−</button>
                    <input class="quantity-selector__input" type="text" value="${item.qty}" readonly>
                    <button type="button" class="quantity-selector__button" data-qty-change="1" data-vid="${item.variantId}" aria-label="Augmenter">+</button>
                  </div>
                  <button type="button" class="line-item__remove" data-remove-vid="${item.variantId}">Supprimer</button>
                </div>
              </div>
            </div>
          `;
        }).join('');

        // Bind quantity modifiers
        drawerItems.querySelectorAll('[data-qty-change]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const vid = btn.getAttribute('data-vid');
            const delta = parseInt(btn.getAttribute('data-qty-change'), 10);
            const current = getLocalCart();
            const target = current.find(i => String(i.variantId) === String(vid));
            if (target) {
              target.qty += delta;
              const filtered = current.filter(i => i.qty > 0);
              saveLocalCart(filtered);
            }
          });
        });

        // Bind remove buttons
        drawerItems.querySelectorAll('[data-remove-vid]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const vid = btn.getAttribute('data-remove-vid');
            const current = getLocalCart();
            const filtered = current.filter(i => String(i.variantId) !== String(vid));
            saveLocalCart(filtered);
          });
        });

        // Update checkout button link to direct permalink
        if (checkoutLink) {
          const permalink = '/cart/' + items.map(i => i.variantId + ':' + i.qty).join(',');
          checkoutLink.setAttribute('href', permalink);
        }
      }
    }

    // 3. Subtotal price in Drawer footer
    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(totalPrice);
    }

    // 4. Free Shipping Bar (2-Tier: 80 € Delivery & 120 € Short Performance)
    const targetGift = 120.0;
    const tier1Threshold = 80.0;
    const tier1Dot = document.getElementById('cart-tier1-dot');
    const giftDot = document.getElementById('cart-gift-dot');

    const pct = Math.min(100, Math.round((totalPrice / targetGift) * 100));
    if (progressFill) {
      progressFill.style.width = pct + '%';
    }

    if (tier1Dot) {
      tier1Dot.classList.toggle('is-active', totalPrice >= tier1Threshold);
    }
    if (giftDot) {
      giftDot.classList.toggle('is-active', totalPrice >= targetGift);
    }

    if (progressMsg) {
      if (totalPrice <= 0) {
        progressMsg.textContent = 'AJOUTEZ 80.00 € POUR LA LIVRAISON OFFERTE.';
      } else if (totalPrice < tier1Threshold) {
        const diff = tier1Threshold - totalPrice;
        progressMsg.textContent = `AJOUTEZ ${formatMoney(diff)} POUR LA LIVRAISON OFFERTE.`;
      } else if (totalPrice < targetGift) {
        const diff = targetGift - totalPrice;
        progressMsg.textContent = `AJOUTEZ ${formatMoney(diff)} POUR OBTENIR SHORT PERFORMANCE OFFERT.`;
      } else {
        progressMsg.textContent = 'FÉLICITATIONS ! LIVRAISON ET SHORT PERFORMANCE OFFERT.';
      }
    }
  }

  /* ------------------------------------------------------------------------
     3. STICKY HEADER & DRAWERS
     ------------------------------------------------------------------------ */
  function initDrawers() {
    const header = document.querySelector('.site-header');
    const backdrop = document.getElementById('drawer-backdrop');
    const menuDrawer = document.getElementById('menu-drawer');
    const cartDrawer = document.getElementById('cart-drawer');
    const searchPanel = document.getElementById('search-panel');

    window.addEventListener(
      'scroll',
      () => {
        if (!header) return;
        header.classList.toggle('is-scrolled', window.scrollY > 36);
      },
      { passive: true }
    );

    function closeAllDrawers() {
      if (menuDrawer) menuDrawer.classList.remove('is-open');
      if (cartDrawer) cartDrawer.classList.remove('is-open');
      if (searchPanel) searchPanel.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
    }

    function openMenu() {
      closeAllDrawers();
      if (menuDrawer && backdrop) {
        menuDrawer.classList.add('is-open');
        backdrop.classList.add('is-open');
        document.body.classList.add('drawer-open');
      }
    }

    function openCart() {
      closeAllDrawers();
      if (cartDrawer && backdrop) {
        updateCartUI();
        cartDrawer.classList.add('is-open');
        backdrop.classList.add('is-open');
        document.body.classList.add('drawer-open');
      }
    }

    function openSearch() {
      closeAllDrawers();
      if (searchPanel && backdrop) {
        searchPanel.classList.add('is-open');
        backdrop.classList.add('is-open');
        const input = searchPanel.querySelector('input');
        if (input) setTimeout(() => input.focus(), 100);
      }
    }

    document.querySelectorAll('[data-open-menu]').forEach((btn) =>
      btn.addEventListener('click', openMenu)
    );
    document.querySelectorAll('[data-close-menu]').forEach((btn) =>
      btn.addEventListener('click', closeAllDrawers)
    );
    document.querySelectorAll('[data-open-cart]').forEach((btn) =>
      btn.addEventListener('click', openCart)
    );
    document.querySelectorAll('[data-close-cart]').forEach((btn) =>
      btn.addEventListener('click', closeAllDrawers)
    );
    document.querySelectorAll('[data-open-search]').forEach((btn) =>
      btn.addEventListener('click', openSearch)
    );
    document.querySelectorAll('[data-close-search]').forEach((btn) =>
      btn.addEventListener('click', closeAllDrawers)
    );

    if (backdrop) {
      backdrop.addEventListener('click', closeAllDrawers);
    }

    // Burger Drawer Expandable '+' Submenus
    document.querySelectorAll('[data-menu-accordion]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.menu-nav-item');
        if (item) item.classList.toggle('is-expanded');
      });
    });

    // Close menu when clicking an anchor link inside menu drawer
    document.querySelectorAll('.menu-drawer a[href^="#"], .menu-drawer a[href*="html"], .menu-drawer a[href*="/products/"]').forEach((link) => {
      link.addEventListener('click', () => {
        closeAllDrawers();
      });
    });

    // Intercept checkout click to guarantee permalink redirection
    const checkoutLink = document.getElementById('cart-drawer-checkout-link');
    if (checkoutLink) {
      checkoutLink.addEventListener('click', (e) => {
        const items = getLocalCart();
        if (items.length > 0) {
          e.preventDefault();
          const permalink = '/cart/' + items.map(i => i.variantId + ':' + i.qty).join(',');
          window.location.href = permalink;
        }
      });
    }

    window.atomgymOpenCart = openCart;
  }

  function initQuickAddButtons() {
    // 1. Product card grid "+" button navigates to PDP
    document.querySelectorAll('.product-card').forEach((card) => {
      const link = card.querySelector('a.product-card-media, a.product-card-title');
      if (link) {
        const plusBtn = card.querySelector('.product-card__quick-add-button');
        if (plusBtn) {
          plusBtn.addEventListener('click', (e) => {
            const href = link.getAttribute('href');
            if (href) {
              window.location.href = href;
            }
          });
        }
      }
    });

    // 2. Cart drawer upsell "+" quick-add
    document.querySelectorAll('[data-quick-add], [data-upsell-vid]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const vid = btn.getAttribute('data-upsell-vid') || '56014490829178';
        const card = btn.closest('.qu-card');
        const cardImg = card ? card.querySelector('.qu-card__media img')?.getAttribute('src') : '';
        const cardTitle = card ? card.querySelector('.qu-card__title')?.textContent?.trim() : 'Ensemble Performance Gris';
        const currentCart = getLocalCart();
        const existing = currentCart.find(i => String(i.variantId) === String(vid));
        if (existing) {
          existing.qty += 1;
        } else {
          currentCart.push({
            key: vid,
            variantId: vid,
            title: cardTitle || 'Ensemble Performance Gris',
            size: 'M',
            price: 59.99,
            image: cardImg || '',
            qty: 1
          });
        }
        saveLocalCart(currentCart);
        syncShopifyBackend(vid, 1);
        if (typeof window.atomgymOpenCart === 'function') {
          window.atomgymOpenCart();
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     4. HOMEPAGE COLLECTION TABS FILTERING & DIRECT TAB REDIRECTS
     ------------------------------------------------------------------------ */
  function initCollectionTabs() {
    const tabs = document.querySelectorAll('[data-collection-tab]');
    const cards = document.querySelectorAll('[data-product-category]');

    function activateTab(filter, shouldScroll) {
      if (!tabs.length || !cards.length) return false;
      const targetTab = document.querySelector(`[data-collection-tab="${filter}"]`);
      if (!targetTab) return false;

      tabs.forEach((t) => t.classList.remove('is-active'));
      targetTab.classList.add('is-active');

      cards.forEach((card) => {
        const cats = (card.getAttribute('data-product-category') || '').split(',');
        if ((filter === 'all' && cats.includes('all')) || (filter !== 'all' && cats.includes(filter))) {
          card.classList.remove('is-hidden');
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (shouldScroll) {
        const section = document.getElementById('collection');
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
      return true;
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const filter = tab.getAttribute('data-collection-tab');
        activateTab(filter, false);
      });
    });

    document.querySelectorAll('[data-goto-tab]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        const filter = trigger.getAttribute('data-goto-tab');
        if (typeof trigger.blur === 'function') trigger.blur();
        if (tabs.length && cards.length) {
          e.preventDefault();
          const menuDrawer = document.getElementById('menu-drawer');
          const backdrop = document.getElementById('drawer-backdrop');
          if (menuDrawer) menuDrawer.classList.remove('is-open');
          if (backdrop) backdrop.classList.remove('is-open');
          document.body.classList.remove('drawer-open');
          activateTab(filter, true);
        }
      });
    });

    try {
      const params = new URLSearchParams(window.location.search);
      const urlTab = params.get('tab');
      if (urlTab) {
        activateTab(urlTab, true);
      }
    } catch (err) {}
  }

  /* ------------------------------------------------------------------------
     5. PDP INTERACTIVE ENGINE (THUMBS, SIZES, AJAX FORM, ACCORDIONS, TABS)
     ------------------------------------------------------------------------ */
  function initPDP() {
    // 5a. Thumbnail gallery switcher
    const mainImg = document.getElementById('pdp-main-img') || document.getElementById('pdp-main-photo');
    const thumbBtns = document.querySelectorAll('.pdp-thumb-btn');
    if (mainImg && thumbBtns.length) {
      thumbBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const src = btn.getAttribute('data-full-src');
          if (src) mainImg.setAttribute('src', src);
          thumbBtns.forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
        });
      });
    }

    // 5b. Size selector & Variant ID sync
    const sizeBtns = document.querySelectorAll('.pdp-size-btn');
    const variantInput = document.getElementById('pdp-selected-variant-id');
    const sizeLabelSpan = document.getElementById('pdp-selected-size');
    const pdpAddBtn = document.getElementById('pdp-add-btn') || document.getElementById('pdp-add-to-cart');

    sizeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        sizeBtns.forEach((b) => {
          b.classList.remove('is-active');
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-active');
        btn.classList.add('is-selected');

        const sizeTitle = btn.getAttribute('data-size') || btn.textContent.trim();
        if (sizeLabelSpan) sizeLabelSpan.textContent = sizeTitle;
        const stickySizeLabel = document.getElementById('pdp-sticky-size-label');
        if (stickySizeLabel) stickySizeLabel.textContent = sizeTitle;

        const variantId = btn.getAttribute('data-variant-id');
        if (variantInput && variantId) {
          variantInput.value = variantId;
        }

        const isAvailable = btn.getAttribute('data-available') !== 'false';
        if (pdpAddBtn) {
          if (!isAvailable) {
            pdpAddBtn.disabled = true;
            pdpAddBtn.innerHTML = '<span>RUPTURE DE STOCK</span>';
            pdpAddBtn.style.opacity = '0.5';
            pdpAddBtn.style.cursor = 'not-allowed';
          } else {
            pdpAddBtn.disabled = false;
            pdpAddBtn.style.opacity = '1';
            pdpAddBtn.style.cursor = 'pointer';
            const priceEl = document.getElementById('pdp-price');
            const priceText = priceEl ? priceEl.textContent.trim() : '59.99 €';
            pdpAddBtn.innerHTML = `<span>AJOUTER AU PANIER</span><span class="pdp-cta-separator">—</span><span class="pdp-cta-price">${priceText}</span>`;
          }
        }
      });
    });

    // 5c. Immediate Bulletproof Add to Cart Handler
    let isAdding = false;
    function handleAddToCart(e) {
      if (e) e.preventDefault();
      if (isAdding) return;
      isAdding = true;

      const submitBtn = document.getElementById('pdp-add-btn') || document.getElementById('pdp-add-to-cart');
      const activeSizeBtn = document.querySelector('.pdp-size-btn.is-active') || document.querySelector('.pdp-size-btn.is-selected');
      const variantId = (variantInput && variantInput.value) || (activeSizeBtn && activeSizeBtn.getAttribute('data-variant-id')) || '55667083510138';
      const sizeTitle = (activeSizeBtn && (activeSizeBtn.getAttribute('data-size') || activeSizeBtn.textContent.trim())) || (sizeLabelSpan && sizeLabelSpan.textContent.trim()) || 'M';
      const prodTitle = document.querySelector('.pdp-title')?.textContent.trim() || 'ENSEMBLE PERFORMANCE NOIR';
      const priceText = document.getElementById('pdp-price')?.textContent.trim() || '59.99 €';
      const priceVal = parseFloat(priceText.replace(/[^0-9.,]/g, '').replace(',', '.') || '59.99');
      const photoEl = document.getElementById('pdp-main-img') || document.getElementById('pdp-main-photo');
      const photoSrc = photoEl ? photoEl.getAttribute('src') : '';

      // Visual feedback on button
      const origBtnHTML = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.innerHTML = '<span>AJOUTÉ AU PANIER ✓</span>';
      }

      // Add to local state immediately
      const currentCart = getLocalCart();
      const existing = currentCart.find(i => String(i.variantId) === String(variantId));
      if (existing) {
        existing.qty += 1;
      } else {
        currentCart.push({
          key: variantId,
          variantId: variantId,
          title: prodTitle,
          size: sizeTitle,
          price: priceVal,
          image: photoSrc,
          qty: 1
        });
      }
      saveLocalCart(currentCart);

      // Background Shopify Sync
      syncShopifyBackend(variantId, 1);

      // Open drawer immediately
      if (typeof window.atomgymOpenCart === 'function') {
        window.atomgymOpenCart();
      }

      setTimeout(() => {
        if (submitBtn) submitBtn.innerHTML = origBtnHTML;
        isAdding = false;
      }, 1000);
    }

    const pdpForm = document.getElementById('pdp-form');
    if (pdpForm) {
      pdpForm.addEventListener('submit', handleAddToCart);
    }
    if (pdpAddBtn) {
      pdpAddBtn.addEventListener('click', handleAddToCart);
    }

    // Sticky Add-to-Cart Bar on Scroll
    const stickyBar = document.getElementById('pdp-sticky-atc');
    const stickyAddBtn = document.getElementById('pdp-sticky-add-btn');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', handleAddToCart);
    }
    if (stickyBar && pdpAddBtn) {
      const checkStickyVisibility = () => {
        const rect = pdpAddBtn.getBoundingClientRect();
        const aiBox = document.getElementById('pdp-ai-prompt-box');
        const aiOpen = aiBox && aiBox.classList.contains('is-open');
        const shouldShow = rect.bottom < 0 && !aiOpen && !document.body.classList.contains('drawer-open');
        stickyBar.classList.toggle('is-visible', shouldShow);
        stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };
      window.addEventListener('scroll', checkStickyVisibility, { passive: true });
      checkStickyVisibility();
    }

    // 5d. Triple Tabs switcher (#tabs-custom)
    const tripleTabs = document.querySelectorAll('#tabs-custom .triple-tabs__tab, .triple-tabs .triple-tabs__tab');
    const triplePanels = document.querySelectorAll('#tabs-custom .triple-tabs__panel, .triple-tabs .triple-tabs__panel');
    tripleTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-tab');
        tripleTabs.forEach((t) => {
          const active = t.getAttribute('data-tab') === id;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        triplePanels.forEach((p) => {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
        });
      });
    });

    // 5e. Size Guide Modal & Scroll
    const sizeModal = document.getElementById('size-guide-modal');
    document.querySelectorAll('[data-open-size-guide]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (sizeModal) {
          sizeModal.classList.add('is-open');
        } else {
          const accordion = document.getElementById('accordion-size-guide') || document.querySelector('details.accordion__disclosure:nth-of-type(2)');
          if (accordion) {
            accordion.open = true;
            const y = accordion.getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }
      });
    });

    document.querySelectorAll('[data-close-size-guide]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (sizeModal) sizeModal.classList.remove('is-open');
      });
    });

    if (sizeModal) {
      sizeModal.addEventListener('click', (e) => {
        if (e.target === sizeModal) sizeModal.classList.remove('is-open');
      });
    }

    document.querySelectorAll('[data-scroll-to-sizechart]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const accordion = document.getElementById('accordion-size-guide') || document.querySelector('details.accordion__disclosure:nth-of-type(2)');
        if (accordion) {
          accordion.open = true;
          const y = accordion.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     6. HERO SWIPER TRACK & PAGINATION DOTS
     ------------------------------------------------------------------------ */
  function initHeroSwiper() {
    const swiper = document.querySelector('.hero-swiper-track');
    const dots = document.querySelectorAll('.hero-dot');
    if (!swiper || !dots.length) return;

    let isScrolling = null;
    swiper.addEventListener('scroll', () => {
      clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        const scrollLeft = swiper.scrollLeft;
        const slideWidth = swiper.querySelector('.hero-slide')?.offsetWidth || swiper.offsetWidth;
        const activeIdx = Math.round(scrollLeft / slideWidth);
        dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === activeIdx);
        });
      }, 50);
    }, { passive: true });

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => {
        const slides = swiper.querySelectorAll('.hero-slide');
        if (slides[idx]) {
          slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     7. SEARCH BAR ENGINE
     ------------------------------------------------------------------------ */
  function initCartAndCheckoutPages() {
    // Dedicated Cart Page renderer
    const cartPageBox = document.getElementById('cart-page-container');
    if (cartPageBox) {
      const items = getLocalCart();
      if (items.length > 0) {
        let total = 0;
        const rows = items.map((item) => {
          const lineTotal = (item.price || 59.99) * (item.qty || 1);
          total += lineTotal;
          return `
            <div class="line-item" style="display:flex;gap:16px;padding:14px 0;border-bottom:1px solid #EFEFEF;">
              <div class="line-item__media" style="width:72px;height:90px;flex-shrink:0;">
                <img src="${item.image || ''}" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;">
              </div>
              <div class="line-item__info" style="flex:1;">
                <div style="font-size:13px;font-weight:800;text-transform:uppercase;">${item.title}</div>
                <div style="font-size:11.5px;color:#666;margin-top:2px;">Taille ${item.size || 'M'}</div>
                <div style="font-size:13.5px;font-weight:800;margin-top:6px;">${formatMoney(lineTotal)}</div>
              </div>
            </div>
          `;
        }).join('');
        const permalink = '/cart/' + items.map(i => i.variantId + ':' + i.qty).join(',');
        cartPageBox.innerHTML = `
          <div>
            ${rows}
            <div style="margin-top:20px;display:flex;justify-content:space-between;align-items:center;">
              <span style="font-size:14px;font-weight:800;text-transform:uppercase;">Sous-total</span>
              <span style="font-size:16px;font-weight:900;">${formatMoney(total)}</span>
            </div>
            <div style="margin-top:16px;">
              <a href="${permalink}" class="btn-black-sharp" style="display:block;text-align:center;text-decoration:none;background:#000;color:#fff;padding:16px;font-weight:800;font-size:13px;letter-spacing:0.04em;text-transform:uppercase;">PASSER LA COMMANDE →</a>
            </div>
          </div>
        `;
      }
    }

    document.querySelectorAll('.search-bar-form').forEach((form) => {
      form.removeAttribute('onsubmit');
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const input = form.querySelector('input');
        const q = ((input && input.value) || '').trim().toLowerCase();
        if (q.includes('rose')) {
          window.location.href = '/products/maillot-rose-hmi-island-azteque';
        } else if (q.includes('bleu') || q.includes('azt') || q.includes('island')) {
          window.location.href = '/products/maillot-bleu-hmi-island-azteque';
        } else if (q.includes('gris')) {
          window.location.href = '/products/ensemble-performance-full-gray';
        } else if (q.includes('blanc')) {
          window.location.href = '/products/pack-essentiel-full-white';
        } else if (q.includes('noir')) {
          window.location.href = '/products/pack-essentiel-full-black';
        } else {
          window.location.href = '/search?q=' + encodeURIComponent(q);
        }
      });
    });
  }

  /* ------------------------------------------------------------------------
     8. ATOMGYM INTELLIGENT AI PRODUCT & SHOPPING ASSISTANT
     ------------------------------------------------------------------------ */
  function initAtomgymAIChat() {
    const STORAGE_KEY = 'atomgym_ai_chat_v2';

    // Mount global AI prompt box inside #global-ai-modal if page has no #pdp-ai-prompt-box
    const globalModal = document.getElementById('global-ai-modal');
    const globalModalCard = document.getElementById('global-ai-modal-card');
    if (!document.getElementById('pdp-ai-prompt-box') && globalModal && globalModalCard) {
      globalModalCard.innerHTML = `
        <div class="pdp-ai-prompt-box is-open" id="pdp-ai-prompt-box" data-product-handle="catalogue-atomgym" data-product-title="Collection ATOMGYM" style="margin:0;border:none;box-shadow:none;padding:4px;">
          <div class="pdp-ai-chat-panel" id="pdp-ai-chat-panel" aria-live="polite">
            <div class="pdp-ai-chat-header">
              <div class="pdp-ai-chat-brand">
                <span class="pdp-ai-status-dot" aria-hidden="true"></span>
                <div class="pdp-ai-chat-titles">
                  <span class="pdp-ai-chat-name">ASSISTANT IA ATOMGYM</span>
                  <span class="pdp-ai-chat-sub">Conseiller Taille, Produits &amp; Commandes</span>
                </div>
              </div>
              <div class="pdp-ai-chat-actions">
                <button type="button" class="pdp-ai-reset-btn" id="pdp-ai-reset-btn" data-ai-reset aria-label="Nouvelle conversation">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
                  <span>Nouveau</span>
                </button>
                <button type="button" class="pdp-ai-close-btn" id="pdp-ai-close-btn" data-ai-close aria-label="Fermer le chat">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              </div>
            </div>
            <div class="pdp-ai-messages" id="pdp-ai-messages" role="log" aria-label="Historique de la conversation"></div>
            <div class="pdp-ai-followup-chips" id="pdp-ai-followup-chips"></div>
          </div>
          <div class="pdp-ai-input-wrap" id="pdp-ai-input-wrap">
            <svg class="pdp-ai-sparkle" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 2L14.39 8.26L21 9.27L16 14.14L17.18 21.02L12 17.77L6.82 21.02L8 14.14L3 9.27L9.61 8.26L12 2Z" fill="currentColor"/>
            </svg>
            <input type="text" class="pdp-ai-input" id="pdp-ai-input" placeholder="Posez n'importe quelle question..." autocomplete="off" enterkeyhint="send">
            <button type="button" class="pdp-ai-send-btn" id="pdp-ai-send-btn" aria-label="Envoyer">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="19" x2="12" y2="5"></line>
                <polyline points="5 12 12 5 19 12"></polyline>
              </svg>
            </button>
          </div>
        </div>
      `;
    }

    const promptBox = document.getElementById('pdp-ai-prompt-box') || document.querySelector('.pdp-ai-prompt-box');
    if (!promptBox) return;

    const inputEl = document.getElementById('pdp-ai-input') || promptBox.querySelector('.pdp-ai-input');
    const sendBtn = document.getElementById('pdp-ai-send-btn') || promptBox.querySelector('.pdp-ai-send-btn');
    const chatPanel = document.getElementById('pdp-ai-chat-panel');
    const messagesEl = document.getElementById('pdp-ai-messages');
    const followupEl = document.getElementById('pdp-ai-followup-chips');
    const quickChipsEl = document.getElementById('pdp-ai-quick-chips');
    const resetBtn = document.getElementById('pdp-ai-reset-btn');
    const closeBtn = document.getElementById('pdp-ai-close-btn');

    if (!inputEl || !sendBtn || !chatPanel || !messagesEl) return;

    // Ensure input is never readonly
    inputEl.removeAttribute('readonly');

    // Parse live product context from Liquid JSON if on a Product Page
    let productCtx = {
      title: promptBox.getAttribute('data-product-title') || document.querySelector('.pdp-title')?.textContent?.trim() || 'Ensemble Performance Noir',
      handle: promptBox.getAttribute('data-product-handle') || window.location.pathname.split('/').pop() || 'pack-essentiel-full-black',
      available: !document.querySelector('.pdp-cta-btn.is-disabled'),
      price: 59.99,
      compare_at_price: 85.70,
      variants: [
        { id: '55667083477370', title: 'S', available: true },
        { id: '55667083510138', title: 'M', available: true },
        { id: '55667083542906', title: 'L', available: true },
        { id: '55667083575674', title: 'XL', available: true }
      ]
    };

    const ctxScript = document.getElementById('atomgym-product-context');
    if (ctxScript) {
      try {
        const parsed = JSON.parse(ctxScript.textContent);
        if (parsed && parsed.title) productCtx = parsed;
      } catch (err) {}
    }

    // Read real DOM size buttons to guarantee 100% live accuracy
    const domSizeBtns = Array.from(document.querySelectorAll('.pdp-size-btn'));
    if (domSizeBtns.length > 0) {
      productCtx.variants = domSizeBtns.map((btn) => ({
        id: btn.getAttribute('data-variant-id') || '',
        title: (btn.getAttribute('data-size') || btn.textContent || '').trim().toUpperCase(),
        available: btn.getAttribute('data-available') !== 'false'
      }));
    }

    const isHmiPage = (productCtx.handle || '').toLowerCase().includes('maillot') || (productCtx.title || '').toLowerCase().includes('maillot');

    // Load or initialize multi-turn conversation state
    function getDefaultState() {
      return {
        isOpen: false,
        messages: [],
        profile: {
          heightCm: null,
          weightKg: null,
          fitPref: null, // 'tight' | 'regular' | 'relaxed'
          lastTopic: null,
          recommendedSize: null
        }
      };
    }

    function loadChatState() {
      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return getDefaultState();
        const data = JSON.parse(raw);
        if (!data || !Array.isArray(data.messages)) return getDefaultState();
        return {
          isOpen: Boolean(data.isOpen),
          messages: data.messages.slice(-24),
          profile: Object.assign(getDefaultState().profile, data.profile || {})
        };
      } catch (err) {
        return getDefaultState();
      }
    }

    function saveChatState(state) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      } catch (err) {}
    }

    let chatState = loadChatState();
    let isGenerating = false;
    let lastFailedQuestion = null;

    function escapeHTML(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function scrollMessagesToBottom(alignLatestBot) {
      requestAnimationFrame(() => {
        if (alignLatestBot) {
          const botMsgs = messagesEl.querySelectorAll('.pdp-ai-msg--bot');
          const lastBot = botMsgs[botMsgs.length - 1];
          if (lastBot) {
            messagesEl.scrollTop = Math.max(0, lastBot.offsetTop - 10);
            return;
          }
        }
        messagesEl.scrollTop = messagesEl.scrollHeight;
      });
    }

    function getWelcomeMessage() {
      if (isHmiPage) {
        return {
          role: 'assistant',
          html: `<p>Bonjour ! Je suis l'assistant IA <strong>ATOMGYM</strong>. Vous consultez le <strong>${escapeHTML(productCtx.title)}</strong> (Édition Limitée Capsule HMI à <strong>34,99 €</strong> au lieu de 49,99 €).</p><p>Posez-moi votre question sur les tailles, la matière, nos Ensembles Performance en stock ou la livraison 24/48h.</p>`,
          actions: [
            { type: 'link', label: 'Voir l\'Ensemble Noir (En stock)', url: '/products/pack-essentiel-full-black', primary: true },
            { type: 'size-guide', label: '📏 Guide des tailles', primary: false }
          ]
        };
      }
      return {
        role: 'assistant',
        html: `<p>Bonjour ! Je suis l'assistant IA <strong>ATOMGYM</strong>. Je connais parfaitement le <strong>${escapeHTML(productCtx.title)}</strong> ainsi que nos coupes, matières et conditions.</p><p>Indiquez-moi votre <strong>taille (cm)</strong> et votre <strong>poids (kg)</strong> pour un conseil taille sur-mesure, ou posez-moi n'importe quelle question !</p>`,
        actions: []
      };
    }

    function renderFollowupChips(chips) {
      if (!followupEl) return;
      const list = chips && chips.length ? chips : [
        'Je fais 1m78 pour 76 kg, quelle taille ?',
        'Coupe & matière 280 GSM',
        'Délais de livraison & retours 30j',
        'Paiement 3x sans frais Scalapay'
      ];
      followupEl.innerHTML = list
        .map((c) => `<button type="button" class="pdp-ai-chip" data-ai-prompt="${escapeHTML(c)}">${escapeHTML(c)}</button>`)
        .join('');
    }

    function renderActionButtons(actions) {
      if (!actions || !actions.length) return '';
      const btns = actions.map((act) => {
        const cls = act.primary ? 'pdp-ai-cta-btn pdp-ai-cta-btn--primary' : 'pdp-ai-cta-btn pdp-ai-cta-btn--secondary';
        if (act.type === 'select-size') {
          return `<button type="button" class="${cls}" data-ai-select-size="${escapeHTML(act.size)}">✓ Sélectionner Taille ${escapeHTML(act.size)}</button>`;
        }
        if (act.type === 'add-to-cart') {
          return `<button type="button" class="${cls}" data-ai-add-size="${escapeHTML(act.size)}">Ajouter Taille ${escapeHTML(act.size)} — ${escapeHTML(act.price || '59,99 €')}</button>`;
        }
        if (act.type === 'size-guide') {
          return `<button type="button" class="${cls}" data-ai-open-sizeguide="1">${escapeHTML(act.label || '📏 Guide des tailles')}</button>`;
        }
        if (act.type === 'link') {
          return `<a href="${escapeHTML(act.url)}" class="${cls}">${escapeHTML(act.label)}</a>`;
        }
        return '';
      }).join('');
      return btns ? `<div class="pdp-ai-msg-actions">${btns}</div>` : '';
    }

    function renderMessages(alignLatestBot) {
      if (!chatState.messages.length) {
        chatState.messages.push(getWelcomeMessage());
      }
      messagesEl.innerHTML = chatState.messages.map((m) => {
        if (m.role === 'user') {
          return `<div class="pdp-ai-msg pdp-ai-msg--user">${escapeHTML(m.text)}</div>`;
        }
        return `<div class="pdp-ai-msg pdp-ai-msg--bot">${m.html || `<p>${escapeHTML(m.text)}</p>`}${renderActionButtons(m.actions)}</div>`;
      }).join('');
      scrollMessagesToBottom(alignLatestBot);
    }

    function openChatPanel() {
      chatState.isOpen = true;
      promptBox.classList.add('is-open');
      chatPanel.removeAttribute('hidden');
      if (quickChipsEl) quickChipsEl.style.display = 'none';
      renderMessages();
      if (!followupEl.innerHTML.trim()) {
        renderFollowupChips();
      }
      saveChatState(chatState);
    }

    function closeChatPanel() {
      chatState.isOpen = false;
      promptBox.classList.remove('is-open');
      chatPanel.setAttribute('hidden', 'hidden');
      if (quickChipsEl) quickChipsEl.style.display = 'flex';
      if (globalModal && !globalModal.hasAttribute('hidden')) {
        globalModal.setAttribute('hidden', 'hidden');
        document.body.classList.remove('drawer-open');
      }
      saveChatState(chatState);
    }

    function resetConversation() {
      chatState = getDefaultState();
      chatState.isOpen = true;
      chatState.messages = [getWelcomeMessage()];
      lastFailedQuestion = null;
      saveChatState(chatState);
      renderMessages();
      renderFollowupChips([
        'Quelle taille choisir ?',
        'Je fais 1m80 pour 80 kg',
        'Coupe & matière 280 GSM',
        'Livraison 24/48h & Retours 30j'
      ]);
      inputEl.value = '';
    }

    // Morphological Size Engine grounded on official ATOMGYM Size Table
    function parseMeasurements(text) {
      const lower = text.toLowerCase().replace(',', '.');
      let heightCm = null;
      let weightKg = null;
      let fitPref = null;

      // Match 1m78, 1.78m, 1m80, 1m75
      const mMeter = lower.match(/\b1\s*(?:m|\.)\s*([4-9]\d)\b/);
      if (mMeter) {
        heightCm = 100 + parseInt(mMeter[1], 10);
      } else if (/\b2\s*(?:m|\.)\s*(0\d)\b/.test(lower)) {
        const m2 = lower.match(/\b2\s*(?:m|\.)\s*(0\d)\b/);
        heightCm = 200 + parseInt(m2[1], 10);
      } else {
        const mCm = lower.match(/\b(1[5-9]\d|20\d)\s*(?:cm|centim)/);
        if (mCm) heightCm = parseInt(mCm[1], 10);
      }

      // Match 75kg, 75 kg, 75 kilos
      const mKg = lower.match(/\b([4-9]\d|1[0-3]\d)\s*(?:kg|kilo|kilos)\b/);
      if (mKg) {
        weightKg = parseInt(mKg[1], 10);
      }

      // If both numbers given like "178 76" or "1m78 pour 76" without "kg"
      if (heightCm && !weightKg) {
        const bareNums = Array.from(lower.matchAll(/\b([4-9]\d|1[0-2]\d)\b/g)).map(m => parseInt(m[1], 10));
        const candidate = bareNums.find(n => n >= 48 && n <= 125 && n !== (heightCm - 100));
        if (candidate) weightKg = candidate;
      }
      if (!heightCm && weightKg) {
        const bareHeight = lower.match(/\b(1[5-9]\d)\b/);
        if (bareHeight) heightCm = parseInt(bareHeight[1], 10);
      }

      // Fit preference detection
      if (/(large|ample|oversize|d[eé]contract|rel[aâ]ch[eé]|confort|pas trop serr|moins serr|au[- ]dessus)/.test(lower)) {
        fitPref = 'relaxed';
      } else if (/(seconde peau|moulant|ajust[eé]|pr[eè]s du corps|serr[eé]|compress|athl[eé]tique)/.test(lower)) {
        fitPref = 'tight';
      } else if (/(normal|standard|habituel|classique)/.test(lower)) {
        fitPref = 'regular';
      }

      return { heightCm, weightKg, fitPref };
    }

    function computeRecommendedSize(heightCm, weightKg, fitPref) {
      // Official ATOMGYM benchmarks:
      // XS: 55-63 kg | S: 64-73 kg (1m68-1m75) | M: 74-82 kg (1m75-1m82) | L: 83-90 kg (1m80-1m88) | XL: 91-98 kg (1m82-1m92) | XXL: 98-110 kg
      const order = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
      let wIdx = 2; // default M
      if (weightKg) {
        if (weightKg <= 63) wIdx = 0;      // XS
        else if (weightKg <= 73) wIdx = 1; // S
        else if (weightKg <= 82) wIdx = 2; // M
        else if (weightKg <= 90) wIdx = 3; // L
        else if (weightKg <= 98) wIdx = 4; // XL
        else wIdx = 5;                     // XXL
      }

      let hIdx = wIdx;
      if (heightCm) {
        if (heightCm < 167) hIdx = 0;
        else if (heightCm <= 174) hIdx = 1;
        else if (heightCm <= 181) hIdx = 2;
        else if (heightCm <= 187) hIdx = 3;
        else if (heightCm <= 193) hIdx = 4;
        else hIdx = 5;
      }

      // Weight is primary for athletic compression wear, height adjusts if tall
      let finalIdx = weightKg ? wIdx : hIdx;
      if (weightKg && heightCm && hIdx > wIdx) {
        finalIdx = Math.min(5, Math.round((wIdx * 0.6 + hIdx * 0.4)));
        if (heightCm >= 185 && finalIdx < 3) finalIdx = 3; // at least L for >=1m85
        if (heightCm >= 178 && finalIdx < 2) finalIdx = 2; // at least M for >=1m78
      }

      // Apply fit preference
      if (fitPref === 'relaxed') {
        finalIdx = Math.min(5, finalIdx + 1);
      } else if (fitPref === 'tight' && weightKg && (weightKg === 73 || weightKg === 82 || weightKg === 90)) {
        // On border weights, keep the snug size
        finalIdx = Math.max(0, finalIdx);
      }

      const idealSize = order[finalIdx];
      // Check available variants on PDP (S, M, L, XL)
      const availVariants = (productCtx.variants || []).filter(v => v.available).map(v => v.title.toUpperCase());
      let stockSize = idealSize;
      if (idealSize === 'XS' && !availVariants.includes('XS')) stockSize = 'S';
      if (idealSize === 'XXL' && !availVariants.includes('XXL')) stockSize = 'XL';

      const altSize = order[Math.min(5, finalIdx + 1)];
      return { idealSize, stockSize, altSize, isStockAvailable: availVariants.includes(stockSize) };
    }

    // Core ATOMGYM Expert Knowledge & Multi-Turn Response Generator
    function buildAtomgymResponse(rawQuestion) {
      const q = rawQuestion.trim();
      const lower = q.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const parsed = parseMeasurements(q);

      if (parsed.heightCm) chatState.profile.heightCm = parsed.heightCm;
      if (parsed.weightKg) chatState.profile.weightKg = parsed.weightKg;
      if (parsed.fitPref) chatState.profile.fitPref = parsed.fitPref;

      const hasMeasurementsNow = Boolean(parsed.heightCm || parsed.weightKg);
      const hasProfileMeasurements = Boolean(chatState.profile.heightCm || chatState.profile.weightKg);
      const isSizingFollowup = chatState.profile.lastTopic === 'sizing' && Boolean(parsed.fitPref || hasMeasurementsNow || /\b(xs|s|m|l|xl|xxl|entre deux|hesite|plutot|serre|large|ample|moulant)\b/.test(lower));
      const isSizingIntent = hasMeasurementsNow || isSizingFollowup || /(taille|tailler|guide|mensuration|mesure|poids|kilo|cm\b|1m\d|grand|petit|moulant|serre|large|oversize|seconde peau|ajust|porter|choisir quoi|prends quoi|prendre quoi|quelle taille)/.test(lower);

      const isMaterialIntent = /(matiere|tissu|composition|gsm|stretch|qualite|transparen|squat|respir|transpir|chaud|leger|couture|fabrication|coupe|lavage|laver|entretien|machine|seche-linge|repass|muscu|sport|entrainement|cardio|courir|running)/.test(lower);
      const isShippingIntent = /(livraison|livrer|livre|delai|expedition|expedie|colissimo|mondial relay|combien de temps|suivi|suivre|colis|commande|frais de port|gratuit|offert|recevoir|recu|quand)/.test(lower);
      const isReturnIntent = /(retour|echang|rembours|essay|30 jour|changer de taille|convient pas|va pas|politique|garantie)/.test(lower);
      const isPaymentIntent = /(paiement|payer|scalapay|3x|3 fois|trois fois|carte|visa|mastercard|apple pay|google pay|shop pay|securis|ssl|prix|promo|reduction|code|remise|combien coute)/.test(lower);
      const isComparisonIntent = /(differenc|compar|autre|couleur|coloris|noir|gris|blanc|hmi|maillot|azteque|bleu|rose|ensemble|pack|catalogue|collection|disponible|stock|rupture|reassort|contient|comprend|haut|bas|short|t-shirt|tee-shirt|vendu)/.test(lower);
      const isAmbassadorIntent = /(ambassadeur|partenariat|sponsor|commission|influenceur|affiliation|contact|support|email|mail|joindre|service client)/.test(lower);

      // Helper for secondary addon when a user combines two questions (e.g. Size + Shipping)
      let extraAddonHTML = '';
      if (isSizingIntent && isShippingIntent) {
        extraAddonHTML += `<p>🚚 <strong>Livraison Express :</strong> Expédition en <strong>24/48h</strong> via Colissimo &amp; Mondial Relay (<strong>Livraison offerte dès 80 €</strong> d'achat, suivi SMS inclus).</p>`;
      }
      if (isSizingIntent && isReturnIntent) {
        extraAddonHTML += `<p>🔄 <strong>Échange facile :</strong> Vous bénéficiez de <strong>30 jours après réception</strong> pour essayer et échanger gratuitement de taille si besoin.</p>`;
      }

      // 1. SIZING & PERSONALIZED MORPHOLOGICAL RECOMMENDATION
      if (isSizingIntent) {
        chatState.profile.lastTopic = 'sizing';

        if (hasProfileMeasurements) {
          const h = chatState.profile.heightCm;
          const w = chatState.profile.weightKg;
          const fit = chatState.profile.fitPref || 'tight';
          const rec = computeRecommendedSize(h, w, fit);
          chatState.profile.recommendedSize = rec.stockSize;

          const dimsLabel = [
            h ? `${(h / 100).toFixed(2).replace('.', 'm')}` : null,
            w ? `${w} kg` : null
          ].filter(Boolean).join(' pour ');

          const fitExplanation = fit === 'relaxed'
            ? `Pour un <strong>porté plus décontracté / moins compressif</strong> avec votre gabarit (${dimsLabel}), nous vous recommandons la taille <strong>${rec.stockSize}</strong>.`
            : `Pour notre coupe signature <strong>Seconde Peau athlétique</strong> avec votre gabarit (${dimsLabel}), votre taille idéale est le <strong>${rec.stockSize}</strong>.`;

          const secondTip = fit === 'relaxed'
            ? `Le tissu technique <strong>280 GSM 4-Way Stretch</strong> conservera une tenue impeccable aux épaules tout en vous laissant plus d'aisance au niveau du buste et de la taille.`
            : `Elle mettra parfaitement en valeur les épaules, les pectoraux et les bras sans comprimer la cage thoracique. <em>(Astuce : si vous préférez un tombé plus ample, optez pour du <strong>${rec.altSize}</strong>)</em>.`;

          const stockNote = isHmiPage
            ? `<p>⚠️ <strong>Note disponibilité :</strong> Ce maillot Édition Limitée HMI est temporairement en réassort, mais la taille <strong>${rec.stockSize}</strong> est disponible immédiatement sur nos <strong>Ensembles Performance Noir, Gris et Blanc</strong>.</p>`
            : `<p>✓ La taille <strong>${rec.stockSize}</strong> est <strong>en stock immédiat</strong> sur cet article (expédition 24/48h).</p>`;

          const actions = isHmiPage
            ? [
                { type: 'link', label: `Voir Ensemble Noir (Taille ${rec.stockSize})`, url: '/products/pack-essentiel-full-black', primary: true },
                { type: 'size-guide', label: '📏 Tableau des tailles', primary: false }
              ]
            : [
                { type: 'select-size', size: rec.stockSize, primary: false },
                { type: 'add-to-cart', size: rec.stockSize, price: productCtx.price_formatted || '59,99 €', primary: true },
                { type: 'size-guide', label: '📏 Guide complet', primary: false }
              ];

          return {
            isMatched: true,
            html: `<p>🎯 <strong>Recommandation sur-mesure ATOMGYM : Taille ${rec.stockSize}</strong></p><p>${fitExplanation}</p><p>${secondTip}</p>${stockNote}${extraAddonHTML}`,
            actions,
            followups: [
              fit === 'relaxed' ? 'Et pour un effet seconde peau ?' : 'Et si je veux une coupe plus large ?',
              'Et si la taille ne me va pas (Échange 30j) ?',
              'Quels sont les délais de livraison ?',
              'Comment entretenir le tissu 280 GSM ?'
            ]
          };
        }

        // User asked about sizing without giving height/weight yet
        const availSizes = (productCtx.variants || []).filter(v => v.available).map(v => v.title).join(', ') || 'S, M, L, XL';
        return {
          isMatched: true,
          html: `
            <p>Nos pièces sont conçues avec une <strong>coupe athlétique Seconde Peau</strong> en fibre extensible <strong>4-Way Stretch</strong>. Prenez votre taille habituelle pour un rendu ajusté près du corps, ou <strong>une taille au-dessus</strong> pour un porté plus décontracté.</p>
            <ul>
              <li><strong>XS</strong> : 55 – 63 kg (Poitrine 84–89 cm)</li>
              <li><strong>S</strong> : 64 – 73 kg • 1m68 – 1m75 (Poitrine 90–95 cm)</li>
              <li><strong>M</strong> : 74 – 82 kg • 1m75 – 1m82 (Poitrine 96–101 cm)</li>
              <li><strong>L</strong> : 83 – 90 kg • 1m80 – 1m88 (Poitrine 102–108 cm)</li>
              <li><strong>XL</strong> : 91 – 98 kg • 1m82 – 1m92 (Poitrine 109–115 cm)</li>
              <li><strong>XXL</strong> : 98 – 110 kg (Poitrine 116–123 cm)</li>
            </ul>
            <p>Tailles disponibles sur cette fiche : <strong>${escapeHTML(availSizes)}</strong>.</p>
            <p>💡 <strong>Vous hésitez ?</strong> Indiquez-moi votre <strong>taille (en cm)</strong>, votre <strong>poids (en kg)</strong> et la <strong>coupe souhaitée</strong> (ajustée ou décontractée), je vous calcule votre taille exacte !</p>
            ${extraAddonHTML}
          `,
          actions: [
            { type: 'size-guide', label: '📏 Ouvrir le Guide des Tailles', primary: true }
          ],
          followups: [
            'Je fais 1m75 pour 70 kg ( Taille S/M )',
            'Je fais 1m78 pour 78 kg ( Taille M )',
            'Je fais 1m83 pour 86 kg ( Taille L )',
            'Je fais 1m88 pour 94 kg ( Taille XL )'
          ]
        };
      }

      // 2. CUT, FABRIC, COMPOSITION & CARE INSTRUCTIONS
      if (isMaterialIntent && !isShippingIntent && !isReturnIntent) {
        chatState.profile.lastTopic = 'material';
        return {
          isMatched: true,
          html: `
            <p>⚡ <strong>Spécifications Techniques &amp; Matière ATOMGYM :</strong></p>
            <ul>
              <li><strong>Grammage Haute Densité (280 GSM) :</strong> Tissu technique lourd et structuré garantissant un tombé parfait et <strong>zéro transparence</strong>, même en tension maximale (squats, soulevé de terre, séances jambes).</li>
              <li><strong>Technologie 4-Way Stretch :</strong> Élasticité dynamique dans les 4 directions qui accompagne chaque mouvement (musculation, cross-training, cardio) sans jamais se déformer au fil des lavages.</li>
              <li><strong>Coupe Athlétique « Seconde Peau » :</strong> Dessinée pour souligner la carrure (épaules, bras, pectoraux) tout en assurant une régulation thermique instantanée et une évacuation rapide de la transpiration.</li>
              <li><strong>Finitions Premium :</strong> Coutures ultra-plates anti-irritation et flocage haute résistance aux frictions.</li>
              <li><strong>Conseils d'entretien :</strong> Lavage en machine à <strong>30°C à l'envers</strong>. Séchage sur cintre à l'air libre. Évitez le sèche-linge et les adoucissants pour préserver la fibre élasthanne.</li>
            </ul>
          `,
          actions: [
            { type: 'size-guide', label: '📏 Choisir ma taille', primary: false }
          ],
          followups: [
            'Quelle taille choisir pour ma morphologie ?',
            'Quelle différence entre le Noir, le Gris et le Blanc ?',
            'Quels sont les délais de livraison ?'
          ]
        };
      }

      // 3. SHIPPING, DELIVERY TIMES, TRACKING & FREE GIFT TIERS (+ RETURNS IF ASKED TOGETHER)
      if (isShippingIntent) {
        chatState.profile.lastTopic = 'shipping';
        const returnAddon = isReturnIntent
          ? `<li><strong>Échanges &amp; Retours (30 jours) :</strong> Vous disposez de <strong>30 jours après réception</strong> pour essayer votre pièce et demander un échange de taille gratuit ou un remboursement (article neuf non lavé, via notre page Contact ou <a href="mailto:atomgym.fr@gmail.com" class="pdp-ai-inline-link">atomgym.fr@gmail.com</a>).</li>`
          : '';
        return {
          isMatched: true,
          html: `
            <p>🚚 <strong>Expédition Express${isReturnIntent ? ' &amp; Retours 30 Jours' : ' &amp; Suivi de Commande'} ATOMGYM :</strong></p>
            <ul>
              <li><strong>Délais d'expédition &amp; livraison :</strong> Expédition rapide et livraison en <strong>24 à 48h ouvrées</strong> via <strong>Colissimo</strong> ou <strong>Mondial Relay</strong>.</li>
              <li><strong>Suivi en temps réel :</strong> Dès l'expédition, vous recevez votre lien de suivi par <strong>SMS et e-mail</strong> (colis avec assurance intégrée).</li>
              <li><strong>Livraison 48h OFFERTE :</strong> Débloquée automatiquement dès <strong>80,00 € d'achat</strong> (par exemple en commandant 2 ensembles).</li>
              <li><strong>Cadeau exclusif dès 120,00 € :</strong> Un <strong>Short Performance Noir</strong> est offert dans votre panier dès 120 € de commande.</li>
              ${returnAddon}
              <li><strong>Suivre une commande en cours :</strong> Rendez-vous dans <a href="/account" class="pdp-ai-inline-link">Mon Compte</a> ou sur notre page <a href="/pages/contact" class="pdp-ai-inline-link">Contact &amp; Support</a> avec votre numéro de commande.</li>
            </ul>
          `,
          actions: [
            { type: 'link', label: 'Page Suivi & Contact', url: '/pages/contact', primary: false }
          ],
          followups: [
            'Comment fonctionnent les échanges et retours (30 jours) ?',
            'Quels sont les moyens de paiement (Scalapay 3x) ?',
            'Quelle taille choisir ?'
          ]
        };
      }

      // 4. EXCHANGES, RETURNS & REFUNDS (30 DAYS)
      if (isReturnIntent) {
        chatState.profile.lastTopic = 'returns';
        return {
          isMatched: true,
          html: `
            <p>🔄 <strong>Politique d'Échanges, Retours &amp; Remboursements (30 Jours) :</strong></p>
            <ul>
              <li><strong>Garantie 30 jours :</strong> Vous disposez de <strong>30 jours après réception</strong> de votre colis pour essayer votre article chez vous en toute sérénité.</li>
              <li><strong>Échange de taille rapide :</strong> Si la coupe est trop ajustée ou trop ample, nous procédons à l'échange vers la taille souhaitée (S, M, L ou XL).</li>
              <li><strong>Conditions :</strong> L'article doit être neuf, non lavé, non porté (hors essayage) et dans son emballage d'origine.</li>
              <li><strong>Comment faire une demande :</strong> Remplissez simplement le formulaire sur <a href="/pages/contact" class="pdp-ai-inline-link">notre page Contact &amp; Support</a> ou écrivez-nous à <a href="mailto:atomgym.fr@gmail.com" class="pdp-ai-inline-link">atomgym.fr@gmail.com</a> en indiquant votre n° de commande (réponse sous 24h, 7j/7).</li>
            </ul>
          `,
          actions: [
            { type: 'link', label: 'Contacter le Support (24h)', url: '/pages/contact', primary: false },
            { type: 'size-guide', label: '📏 Vérifier le Guide des Tailles', primary: true }
          ],
          followups: [
            'Quelle taille me conseillez-vous ?',
            'Quels sont les délais de livraison 24/48h ?',
            'Puis-je payer en 3 fois sans frais ?'
          ]
        };
      }

      // 5. PAYMENT METHODS, SCALAPAY 3X & PRICING/PROMOS
      if (isPaymentIntent) {
        chatState.profile.lastTopic = 'payment';
        const priceNum = Number(productCtx.price) || 59.99;
        const scalaInstallment = (priceNum / 3).toFixed(2).replace('.', ',');
        return {
          isMatched: true,
          html: `
            <p>🔒 <strong>Moyens de Paiement 100% Sécurisés &amp; Facilités :</strong></p>
            <ul>
              <li><strong>Paiement en 3x sans frais avec Scalapay :</strong> Réglez cet article en <strong>3 mensualités de ${scalaInstallment} € sans aucun frais</strong> (validation instantanée).</li>
              <li><strong>Cartes Bancaires :</strong> CB, Visa, Mastercard et American Express.</li>
              <li><strong>Paiements Express 1-Clic :</strong> <strong>Apple Pay</strong>, <strong>Google Pay</strong> et <strong>Shop Pay</strong>.</li>
              <li><strong>Sécurité Maximale :</strong> Transactions intégralement chiffrées via le protocole bancaire <strong>SSL 256-bit</strong>.</li>
              <li><strong>Offre actuelle (-30%) :</strong> Nos Ensembles Performance complets (T-Shirt + Short) sont actuellement à <strong>59,99 € au lieu de 85,70 €</strong> (et la livraison est offerte dès 80 € d'achat).</li>
            </ul>
          `,
          actions: [],
          followups: [
            'Quelle taille choisir ?',
            'Quels sont les délais de livraison ?',
            'Comparer les coloris Noir, Gris et Blanc'
          ]
        };
      }

      // 6. PRODUCT COMPARISON & CATALOG ADVICE
      if (isComparisonIntent) {
        chatState.profile.lastTopic = 'comparison';
        return {
          isMatched: true,
          html: `
            <p>👕 <strong>Guide Comparatif de la Collection ATOMGYM :</strong></p>
            <ul>
              <li><strong>Pack Complet 2 Pièces :</strong> Chaque <strong>Ensemble Performance</strong> comprend le <strong>T-Shirt Seconde Peau + le Short Performance assorti</strong> en fibre 280 GSM 4-Way Stretch.</li>
              <li><strong>Ensemble Performance Noir (59,99 € <del>85,70 €</del> • En stock) :</strong> Notre best-seller n°1. Sobriété absolue, polyvalent pour la salle comme en lifestyle urbain, effet affûtant immédiat.</li>
              <li><strong>Ensemble Performance Gris (59,99 € <del>85,70 €</del> • En stock) :</strong> Teinte Studio Grey qui accentue particulièrement les volumes et le relief musculaire sous l'éclairage de salle.</li>
              <li><strong>Ensemble Performance Blanc (59,99 € <del>85,70 €</del> • En stock) :</strong> Rendu visuel ultra-premium et lumineux, conçu en 280 GSM haute densité pour garantir zéro transparence.</li>
              <li><strong>Capsule HMI — Maillots Bleu &amp; Rose Aztèque (34,99 € <del>49,99 €</del>) :</strong> Maillot seul en édition limitée Island Aztèque n°10. <em>Actuellement en cours de réassort (bientôt de retour en stock).</em></li>
            </ul>
            <p>💡 <strong>Le conseil ATOMGYM :</strong> Pour un premier achat, l'<strong>Ensemble Performance Noir</strong> ou <strong>Gris</strong> est un indispensable. Si vous prenez 2 ensembles (ex: Noir + Gris), vous débloquez la <strong>Livraison Express 48h Offerte</strong> !</p>
          `,
          actions: [
            { type: 'link', label: 'Ensemble Noir (59,99 €)', url: '/products/pack-essentiel-full-black', primary: true },
            { type: 'link', label: 'Ensemble Gris (59,99 €)', url: '/products/ensemble-performance-full-gray', primary: false },
            { type: 'link', label: 'Ensemble Blanc (59,99 €)', url: '/products/pack-essentiel-full-white', primary: false }
          ],
          followups: [
            'Quelle taille choisir pour ma morphologie ?',
            'Détails sur la matière 280 GSM 4-Way Stretch',
            'Livraison 24/48h & cadeaux dès 80€ / 120€'
          ]
        };
      }

      // 7. AMBASSADOR PROGRAM & SUPPORT CONTACT
      if (isAmbassadorIntent) {
        chatState.profile.lastTopic = 'ambassador';
        return {
          isMatched: true,
          html: `
            <p>🤝 <strong>Programme Ambassadeur &amp; Support Client ATOMGYM :</strong></p>
            <ul>
              <li><strong>Programme Ambassadeur :</strong> Vous êtes athlète, coach sportif ou créateur fitness ? Bénéficiez de <strong>15% de commission</strong> sur chaque commande générée et recevez nos pièces exclusives en avant-première.</li>
              <li><strong>Contact &amp; Support 7j/7 :</strong> Notre équipe vous répond sous 24h via <a href="/pages/contact" class="pdp-ai-inline-link">notre formulaire de contact</a> ou directement par e-mail à <a href="mailto:atomgym.fr@gmail.com" class="pdp-ai-inline-link">atomgym.fr@gmail.com</a>.</li>
            </ul>
          `,
          actions: [
            { type: 'link', label: 'Ouvrir la page Contact', url: '/pages/contact', primary: true }
          ],
          followups: [
            'Quelle taille choisir ?',
            'Comparer les Ensembles Performance',
            'Livraison 24/48h & Retours 30j'
          ]
        };
      }

      // 8. DEFAULT / GENERAL PRODUCT ADVISORY (Contextual to current page)
      chatState.profile.lastTopic = 'general';
      const activeSize = document.querySelector('.pdp-size-btn.is-active')?.getAttribute('data-size') || 'M';
      return {
        isMatched: false,
        html: `
          <p>Je suis à votre disposition pour vous conseiller sur le <strong>${escapeHTML(productCtx.title)}</strong> (${escapeHTML(productCtx.price_formatted || '59,99 €')} au lieu de ${escapeHTML(productCtx.compare_at_price_formatted || '85,70 €')}, soit <strong>-30%</strong>).</p>
          <ul>
            <li><strong>Coupe &amp; Matière :</strong> Coupe athlétique <em>Seconde Peau</em> en fibre technique <strong>280 GSM 4-Way Stretch</strong> (maintien musculaire ciblé, zéro transparence).</li>
            <li><strong>Conseil Taille :</strong> Dites-moi simplement votre <strong>taille (cm)</strong> et votre <strong>poids (kg)</strong> (ex: <em>« 1m78 pour 76 kg »</em>) pour connaître votre taille idéale.</li>
            <li><strong>Services Inclus :</strong> Expédition Express <strong>24/48h</strong> (Colissimo / Mondial Relay), <strong>Livraison offerte dès 80 €</strong>, retours faciles sous <strong>30 jours</strong> et paiement en <strong>3x sans frais Scalapay</strong>.</li>
          </ul>
        `,
        actions: isHmiPage
          ? [{ type: 'link', label: 'Voir les Ensembles en stock', url: '/products/pack-essentiel-full-black', primary: true }]
          : [
              { type: 'size-guide', label: '📏 Guide des tailles', primary: false },
              { type: 'add-to-cart', size: activeSize, price: productCtx.price_formatted || '59,99 €', primary: true }
            ],
        followups: [
          'Je fais 1m78 pour 76 kg, quelle taille choisir ?',
          'Quelles sont les différences entre Noir, Gris et Blanc ?',
          'Quels sont les délais de livraison et retours ?',
          'Comment laver et entretenir mon ensemble ?'
        ]
      };
    }

    // Perform real network verification & server-side AI enrichment for open-ended queries
    async function fetchAIResponse(questionText) {
      if (window.__ATOMGYM_FORCE_AI_ERROR === true || (typeof navigator !== 'undefined' && navigator.onLine === false)) {
        throw new Error('NETWORK_ERROR');
      }

      // 1. Verify store connectivity with a fast GET probe to Shopify's /cart.js
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 3500);
      try {
        const probeUrl = window.location.protocol.startsWith('http') ? '/cart.js' : null;
        if (probeUrl) {
          const resp = await fetch(probeUrl, {
            method: 'GET',
            headers: { 'Accept': 'application/json' },
            signal: controller.signal
          });
          if (!resp.ok && resp.status >= 500) {
            throw new Error('SERVER_ERROR');
          }
        }
      } catch (err) {
        clearTimeout(timeoutId);
        if (err && (err.name === 'AbortError' || err.message === 'NETWORK_ERROR' || err.message === 'Failed to fetch')) {
          throw new Error('NETWORK_ERROR');
        }
      } finally {
        clearTimeout(timeoutId);
      }

      const localReply = buildAtomgymResponse(questionText);
      if (localReply.isMatched) {
        await new Promise((resolve) => setTimeout(resolve, 320));
        return localReply;
      }

      // 2. For open-ended questions, query keyless server-side LLM with strict ATOMGYM ground-truth system prompt
      try {
        const llmCtrl = new AbortController();
        const llmTimer = setTimeout(() => llmCtrl.abort(), 2400);
        const sysPrompt = [
          'Tu es l assistant IA officiel de la marque francaise ATOMGYM (atomgym.fr). Reponds toujours en francais, de facon concise (2 a 4 phrases max), professionnelle et oriente vers l aide a l achat.',
          'Faits stricts (ne jamais inventer) :',
          '- Ensembles Performance (Noir, Gris, Blanc) : pack 2 pieces (T-shirt + Short) a 59,99 EUR au lieu de 85,70 EUR (-30%), en stock tailles S, M, L, XL.',
          '- Maillots Capsule HMI (Bleu Azteque, Rose Azteque) : 34,99 EUR au lieu de 49,99 EUR, edition limitee temporairement indisponible.',
          '- Coupe & Matiere : Coupe athletique Seconde Peau, fibre technique 280 GSM extensible 4-Way Stretch, zero transparence, lavage 30C a l envers sans seche-linge.',
          '- Guide des tailles : XS (55-63kg), S (64-73kg, 1m68-1m75), M (74-82kg, 1m75-1m82), L (83-90kg, 1m80-1m88), XL (91-98kg, 1m82-1m92), XXL (98-110kg).',
          '- Livraison & Retours : Expedition 24/48h Colissimo & Mondial Relay, suivi SMS, livraison offerte des 80 EUR, Short Performance offert des 120 EUR. Retours et echanges sous 30 jours.',
          '- Paiement : 100% securise SSL 256-bit, CB/Visa/Mastercard/Amex, Apple Pay, Google Pay, Shop Pay, et 3x sans frais Scalapay.',
          `- Produit consulte actuellement : ${productCtx.title} (${productCtx.price_formatted || '59,99 EUR'}).`
        ].join('\n');

        const historyMsgs = chatState.messages.slice(-6).map((m) => ({
          role: m.role === 'user' ? 'user' : 'assistant',
          content: m.text || (m.html ? m.html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() : '')
        }));

        const llmResp = await fetch('https://text.pollinations.ai/openai', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            model: 'openai',
            messages: [{ role: 'system', content: sysPrompt }].concat(historyMsgs),
            temperature: 0.3
          }),
          signal: llmCtrl.signal
        });
        clearTimeout(llmTimer);
        if (llmResp.ok) {
          const data = await llmResp.json();
          const aiText = data?.choices?.[0]?.message?.content?.trim();
          if (aiText && aiText.length > 15) {
            const formatted = aiText
              .split(/\n{2,}/)
              .map((p) => `<p>${escapeHTML(p).replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')}</p>`)
              .join('');
            return {
              html: formatted,
              actions: localReply.actions,
              followups: localReply.followups
            };
          }
        }
      } catch (e) {
        // Fallback seamlessly to grounded localReply
      }

      await new Promise((resolve) => setTimeout(resolve, 280));
      return localReply;
    }

    async function handleSendQuestion(rawText) {
      const text = (rawText !== undefined ? rawText : inputEl.value).trim();
      if (!text || isGenerating) return;

      isGenerating = true;
      lastFailedQuestion = null;
      inputEl.value = '';
      sendBtn.disabled = true;

      openChatPanel();

      // Remove any previous error box
      messagesEl.querySelectorAll('.pdp-ai-error-box').forEach((el) => el.remove());

      // Append user message if not already the last message (e.g. on retry)
      const lastMsg = chatState.messages[chatState.messages.length - 1];
      if (!lastMsg || lastMsg.role !== 'user' || lastMsg.text !== text) {
        chatState.messages.push({
          role: 'user',
          text: text,
          timestamp: Date.now()
        });
        saveChatState(chatState);
        renderMessages();
      }

      // Show loading/typing indicator
      const typingEl = document.createElement('div');
      typingEl.className = 'pdp-ai-typing';
      typingEl.id = 'pdp-ai-typing-indicator';
      typingEl.innerHTML = `
        <div class="pdp-ai-dots" aria-hidden="true"><span></span><span></span><span></span></div>
        <span>Assistant ATOMGYM rédige...</span>
      `;
      messagesEl.appendChild(typingEl);
      scrollMessagesToBottom();

      try {
        const reply = await fetchAIResponse(text);
        typingEl.remove();

        chatState.messages.push({
          role: 'assistant',
          html: reply.html,
          actions: reply.actions || [],
          timestamp: Date.now()
        });
        saveChatState(chatState);
        renderMessages(true);
        if (reply.followups) {
          renderFollowupChips(reply.followups);
        }
      } catch (err) {
        typingEl.remove();
        lastFailedQuestion = text;
        const errBox = document.createElement('div');
        errBox.className = 'pdp-ai-error-box';
        errBox.setAttribute('role', 'alert');
        errBox.innerHTML = `
          <span>Connexion interrompue. Impossible de récupérer la réponse pour le moment.</span>
          <button type="button" class="pdp-ai-retry-btn" data-ai-retry>↻ Réessayer</button>
        `;
        messagesEl.appendChild(errBox);
        scrollMessagesToBottom();
      } finally {
        isGenerating = false;
        sendBtn.disabled = false;
      }
    }

    // Event Listeners: Input focus, Enter key, Send arrow button
    sendBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (inputEl.value.trim()) {
        handleSendQuestion(inputEl.value);
      } else {
        openChatPanel();
        inputEl.focus();
      }
    });

    inputEl.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (inputEl.value.trim()) {
          handleSendQuestion(inputEl.value);
        }
      } else if (e.key === 'Escape' && chatState.isOpen) {
        closeChatPanel();
      }
    });

    // Mobile virtual keyboard (visualViewport) safety: ensure input & send button are never masked
    inputEl.addEventListener('focus', () => {
      setTimeout(() => {
        const rect = promptBox.getBoundingClientRect();
        const vHeight = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
        if (rect.bottom > vHeight - 16 || rect.top < 60) {
          promptBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 260);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => {
        if (document.activeElement === inputEl) {
          scrollMessagesToBottom();
        }
      });
    }

    // Quick chips & follow-up chips delegation
    promptBox.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-ai-prompt]');
      if (chip) {
        e.preventDefault();
        const promptText = chip.getAttribute('data-ai-prompt');
        if (promptText) handleSendQuestion(promptText);
        return;
      }

      const retryBtn = e.target.closest('[data-ai-retry]');
      if (retryBtn) {
        e.preventDefault();
        const qToRetry = lastFailedQuestion || 'Quelle taille choisir ?';
        handleSendQuestion(qToRetry);
        return;
      }

      const selectSizeBtn = e.target.closest('[data-ai-select-size]');
      if (selectSizeBtn) {
        e.preventDefault();
        const targetSize = (selectSizeBtn.getAttribute('data-ai-select-size') || '').toUpperCase();
        const matchingBtn = Array.from(document.querySelectorAll('.pdp-size-btn')).find(
          (b) => (b.getAttribute('data-size') || b.textContent || '').trim().toUpperCase() === targetSize
        );
        if (matchingBtn) {
          matchingBtn.click();
          selectSizeBtn.textContent = `✓ Taille ${targetSize} sélectionnée`;
        }
        return;
      }

      const addSizeBtn = e.target.closest('[data-ai-add-size]');
      if (addSizeBtn) {
        e.preventDefault();
        const targetSize = (addSizeBtn.getAttribute('data-ai-add-size') || '').toUpperCase();
        const matchingBtn = Array.from(document.querySelectorAll('.pdp-size-btn')).find(
          (b) => (b.getAttribute('data-size') || b.textContent || '').trim().toUpperCase() === targetSize
        );
        if (matchingBtn) matchingBtn.click();
        const mainAddBtn = document.getElementById('pdp-add-to-cart') || document.getElementById('pdp-add-btn');
        if (mainAddBtn && !mainAddBtn.disabled) {
          mainAddBtn.click();
        }
        return;
      }

      const openGuideBtn = e.target.closest('[data-ai-open-sizeguide]');
      if (openGuideBtn) {
        e.preventDefault();
        const sizeModal = document.getElementById('size-guide-modal');
        if (sizeModal) {
          sizeModal.classList.add('is-open');
        }
        return;
      }
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', (e) => {
        e.preventDefault();
        resetConversation();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closeChatPanel();
      });
    }

    // Global menu trigger [data-open-ai-assistant]
    document.querySelectorAll('[data-open-ai-assistant]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const menuDrawer = document.getElementById('menu-drawer');
        const backdrop = document.getElementById('drawer-backdrop');
        if (menuDrawer) menuDrawer.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        document.body.classList.remove('drawer-open');

        if (globalModal && globalModal.contains(promptBox)) {
          globalModal.removeAttribute('hidden');
        } else {
          promptBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        openChatPanel();
        setTimeout(() => inputEl.focus(), 200);
      });
    });

    if (globalModal) {
      globalModal.addEventListener('click', (e) => {
        if (e.target === globalModal) {
          closeChatPanel();
        }
      });
    }

    // Restore open state if conversation already had user messages in this session
    if (chatState.isOpen && chatState.messages.some((m) => m.role === 'user')) {
      openChatPanel();
    }
  }

  // Strictly prevent unwanted double tap zoom on iOS Safari
  document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
  });
  document.addEventListener('gesturechange', function (e) {
    e.preventDefault();
  });
  document.addEventListener('gestureend', function (e) {
    e.preventDefault();
  });

  document.addEventListener('DOMContentLoaded', () => {
    initVideos();
    initDrawers();
    initHeroSwiper();
    updateCartUI();
    initQuickAddButtons();
    initCollectionTabs();
    initPDP();
    initCartAndCheckoutPages();
    initAtomgymAIChat();
  });
})();
